<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     搜索框
  +---------------------------------------------------------------------------------------
-->
<template>
  <!-- <el-input
    v-model="keyword"
    clearable
    :placeholder="placeholder"
    :disabled="disabled"
    prefix-icon="el-icon-search"
    @change="inputChange"
    style="width:100%;"
  /> -->
  <div class="search">
    <el-popover v-model="visible" trigger="manual" placement="bottom-start" popper-class="history-record">
      <el-input slot="reference" ref="input" v-model="keyword" clearable :placeholder="placeholder" prefix-icon="el-icon-search" 
      @change="inputChange" @focus="inputFocus" @blur="inputBlur" @clear="clearInput" style="width:100%;"></el-input>
      <div v-if="list.length" class="history">
        <ul>
          <li v-for="(item, idx) in list" :key="idx" @click="selectItem(item)">{{ item }}</li>
        </ul>
        <div class="clearAll" @click="deleteAll()">清空</div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "FSearchInput",

  props: {
    placeholder: {
      type: String,
      default: "搜索",
    },

    value: {
      type: String,
      default: "",
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      list: [],
      visible: false
    };
  },

  computed: {
    keyword: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    keyword(val1,val2) {
      if(val1.toString().length !== 0) {
        this.visible = false
      }else {
        this.visible = true
      }
    }
  },

  created() {
    this.list = JSON.parse(localStorage.getItem("__SEARCH_HISTORY__")) || [];
  },

  methods: {
    deleteAll() {
      this.list = [];
      this.keyword = "";
      localStorage.setItem("__SEARCH_HISTORY__", JSON.stringify(this.list));
    },
    selectItem(item) {
      this.keyword = item;
      const i = this.list.indexOf(item);
      this.list.splice(i, 1);
      this.list.unshift(item);
      localStorage.setItem("__SEARCH_HISTORY__", JSON.stringify(this.list));
      this.$emit("change", this.keyword);
    },
    inputChange() {
      if (!this.keyword){
        this.$emit("change", this.keyword);
        return;
      } 
      const tempKeyword = this.keyword.toString();
      if(tempKeyword.trim().length == 0) {
        this.$emit("change", tempKeyword.trim());
        return;
      }
      if (this.list.length < 5) {
        if (this.list.indexOf(tempKeyword) != -1) {
          const i = this.list.indexOf(tempKeyword);
          this.list.splice(i, 1);
          this.list.unshift(tempKeyword);
          localStorage.setItem("__SEARCH_HISTORY__", JSON.stringify(this.list));
          this.$emit("change", this.keyword);
          return;
        }
        this.list.unshift(tempKeyword);
        localStorage.setItem("__SEARCH_HISTORY__", JSON.stringify(this.list));
      } else {
        if (this.list.indexOf(tempKeyword) != -1) {
          const i = this.list.indexOf(tempKeyword);
          this.list.splice(i, 1);
          this.list.unshift(tempKeyword);
          localStorage.setItem("__SEARCH_HISTORY__", JSON.stringify(this.list));
          this.$emit("change", this.keyword);
          return;
        }
        this.list.unshift(tempKeyword);
        this.list.pop();
        localStorage.setItem("__SEARCH_HISTORY__", JSON.stringify(this.list));
      }
      this.$emit("change", this.keyword);
    },
    inputFocus() {
      this.visible = true
      if(this.keyword.toString().length != 0){
        this.visible = false
      }
    },
    inputBlur() {
      this.visible = false
    },
    clearInput() {
      this.visible = false
      this.$refs.input.focus();
      // this.$refs.input.blur();
    },
  },
};
</script>

<style lang="scss">
.el-popover.el-popper.history-record {
  padding: 0px;
  .popper__arrow::after {
    display: none;
  }
  .history {
    width: 220px;
    font-size: 14px;
    ul {
      margin: 0;
      padding-top: 10px;

      li {
        list-style: none;
        height: 35px;
        line-height: 35px;
        padding: 0 10px;
        cursor: pointer;

        &:hover {
          background-color: rgba(238, 240, 245, 1);
        }
      }
    }
    .clearAll {
      width: 100%;
      text-align: center;
      height: 35px;
      line-height: 35px;
      margin-bottom: 10px;
      cursor: pointer;
      &:hover {
        background-color: rgba(238, 240, 245, 1);
      }
    }
  }
}
</style>
